export enum MainComplaintStatus {
    Active = 0,
    Resolved = 1,
  }